<template>
  <div class="flex-none w-56">
    <!-- Date marker (orange) sitting above the card, like the Figma timeline. -->
    <p
      class="text-highlight text-[11px] tracking-wide mb-2 h-4 truncate"
      :class="{ 'opacity-0': !label }"
    >
      <template v-if="label">
        <span class="font-bold uppercase">{{ label.month }}</span
        >{{ label.day }}
        <span class="font-light"> - {{ label.status }}</span>
      </template>
      <template v-else>&nbsp;</template>
    </p>

    <!-- Backdrop (16:9) -->
    <div
      class="w-full aspect-video rounded-lg overflow-hidden bg-primary-500 border border-primary-400"
    >
      <img
        v-if="image"
        :src="image"
        class="h-full w-full object-cover"
        :alt="series.name"
      />
    </div>

    <!-- Meta (centered) -->
    <div class="pt-3 text-center">
      <p class="text-white text-sm truncate">
        {{ series.name }}
        <span v-if="year" class="text-muted">({{ year }})</span>
      </p>
      <p
        v-if="episode"
        class="text-subtle text-xs tracking-widest opacity-80 mt-1"
      >
        {{ episode }}
      </p>

      <!-- Vote -->
      <SeriesVote :series="series" center class="mt-2" />
    </div>
  </div>
</template>

<script>
import {
  upcomingLabel,
  seriesYear,
  episodeLabel,
  seriesImage,
} from "@/utils/series";
import SeriesVote from "@/components/series/SeriesVote.vue";

export default {
  name: "UpcomingCard",
  components: { SeriesVote },
  props: {
    series: { required: true },
  },

  computed: {
    image() {
      return seriesImage(this.series, "backdrop");
    },
    label() {
      return upcomingLabel(this.series);
    },
    year() {
      return seriesYear(this.series);
    },
    episode() {
      return episodeLabel(this.series);
    },
  },
};
</script>
